<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: '80vw', maxWidth: '1100px' }"
  [breakpoints]="{ '960px': '95vw' }"
  (onHide)="onHide()"
  styleClass="validation-results-dialog"
>
  <ng-template pTemplate="header">
    <div class="p-d-flex p-ai-center" style="gap: 0.5rem;">
      <i
        class="fa-solid"
        [ngClass]="result?.passed ? 'fa-circle-check' : 'fa-circle-exclamation'"
        [ngStyle]="{ color: result?.passed ? 'var(--green-500, #22c55e)' : 'var(--red-500, #ef4444)' }"
      ></i>
      <span>Validation results — {{ result?.entityLabel }}</span>
      <p-tag
        [severity]="result?.passed ? 'success' : 'danger'"
        [value]="result?.passed ? 'Passed' : (result?.totalFindings + ' issue(s)')"
      ></p-tag>
    </div>
  </ng-template>

  <div *ngIf="result?.passed" class="p-p-2">
    <p-message
      severity="success"
      text="All checks passed — this {{ result?.entityType }} meets the release criteria."
    ></p-message>
  </div>

  <div *ngFor="let group of groupedFindings" class="p-mb-3">
    <h4 class="p-mb-2">
      {{ sectionLabel(group.section) }}
      <span class="p-text-secondary">({{ group.findings.length }})</span>
    </h4>
    <p-table [value]="group.findings" styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%;">Entity</th>
          <th style="width: 20%;">Field</th>
          <th style="width: 20%;">Property</th>
          <th>Reason</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-finding>
        <tr>
          <td>
            {{ finding.entityLabel }}
            <ng-container *ngIf="finding.entityId != null">
              <a
                *ngIf="entityHref(finding) as href; else plainId"
                [href]="href"
                target="_blank"
                rel="noopener"
                [ngStyle]="{ color: 'var(--primary-color)', cursor: 'pointer' }"
                (click)="onLinkClick($event, finding)"
                >({{ finding.entityId }})</a
              >
              <ng-template #plainId>
                <span class="p-text-secondary">({{ finding.entityId }})</span>
              </ng-template>
            </ng-container>
            <span class="p-text-secondary"> ({{ finding.entityType }})</span>
          </td>
          <td>{{ finding.fieldName }}</td>
          <td><code>{{ finding.fieldPath }}</code></td>
          <td>{{ finding.message }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>
